export interface HealthTopicsCheckbox {
  key: number;
  label: string;
  fieldName: SurveyBooleanEnums;
}

export interface SurveyForm {
  healthTopicsChecked: SurveyBooleanEnums[];
  otherIdea: string | '';
  radioAnswer: 'Yes' | 'No' | '';
  contactName: string | '';
  contactEmail: string | '';
  contactPhone: string | '';
}

export enum SurveyBooleanEnums {
  checkHeartCare = 'checkHeartCare',
  checkRespiratoryIll = 'checkRespiratoryIll',
  checkCancer = 'checkCancer',
  checkPhysicalTherapy = 'checkPhysicalTherapy',
  checkChronic = 'checkChronic',
  checkFertility = 'checkFertility',
  checkChild = 'checkChild',
  checkGenetics = 'checkGenetics',
  checkSleep = 'checkSleep',
  checkSurgical = 'checkSurgical',
  checkDigestiveHealth = 'checkDigestiveHealth',
  checkSubstance = 'checkSubstance',
  checkTobacco = 'checkTobacco',
  checkSexualHealth = 'checkSexualHealth',
  checkFitnessTracker = 'checkFitnessTracker',
  checkNutrition = 'checkNutrition',
  checkHealthCoaching = 'checkHealthCoaching'
}

export const HEALTH_TOPICS_CHECKBOXES: HealthTopicsCheckbox[] = [
  {
    key: 2,
    label: 'Heart Care',
    fieldName: SurveyBooleanEnums.checkHeartCare
  },
  {
    key: 3,
    label: 'Respiratory Illnesses',
    fieldName: SurveyBooleanEnums.checkRespiratoryIll
  },
  {
    key: 5,
    label: 'Cancer Management and Prevention',
    fieldName: SurveyBooleanEnums.checkCancer
  },
  {
    key: 6,
    label: 'Physical Therapy/Rehabilitation Management',
    fieldName: SurveyBooleanEnums.checkPhysicalTherapy
  },
  {
    key: 7,
    label: 'Chronic Pain Management',
    fieldName: SurveyBooleanEnums.checkChronic
  },
  {
    key: 8,
    label: 'Fertility/Pregnancy/Perinatal Care',
    fieldName: SurveyBooleanEnums.checkFertility
  },
  {
    key: 9,
    label: 'Child Development',
    fieldName: SurveyBooleanEnums.checkChild
  },
  {
    key: 10,
    label: 'Genetics',
    fieldName: SurveyBooleanEnums.checkGenetics
  },
  {
    key: 11,
    label: 'Sleep Management',
    fieldName: SurveyBooleanEnums.checkSleep
  },
  {
    key: 12,
    label: 'Surgical and Non-surgical Weight Loss',
    fieldName: SurveyBooleanEnums.checkSurgical
  },
  {
    key: 13,
    label: 'Digestive Health',
    fieldName: SurveyBooleanEnums.checkDigestiveHealth
  },
  {
    key: 14,
    label: 'Substance Abuse',
    fieldName: SurveyBooleanEnums.checkSubstance
  },
  {
    key: 15,
    label: 'Tobacco and/or Alcohol Cessation',
    fieldName: SurveyBooleanEnums.checkTobacco
  },
  {
    key: 16,
    label: 'Sexual Health',
    fieldName: SurveyBooleanEnums.checkSexualHealth
  },
  {
    key: 17,
    label: 'Fitness Tracker Integration (e.g. Apple Health, Google Fit, etc.)',
    fieldName: SurveyBooleanEnums.checkFitnessTracker
  },
  {
    key: 18,
    label: 'Nutrition/Physical Fitness',
    fieldName: SurveyBooleanEnums.checkNutrition
  },
  {
    key: 19,
    label: 'Your Health Goals/Health Coaching',
    fieldName: SurveyBooleanEnums.checkHealthCoaching
  }
];
